// @flow
import { durationLabel, durationValue } from '../util/common';

class SignPrice {
  code: string;
  price: number;
  daysDuration: number;

  static parseList(raw: any[]): SignPrice[] {
    let list: SignPrice[] = [];
    if (raw) {
      for (let item of raw) {
        const price: ?SignPrice = SignPrice.parse(item);
        if (price) {
          list.push(price);
        }
      }
    }
    return list;
  }

  static parse(raw: any): ?SignPrice {
    if (raw) {
      let price: SignPrice = new SignPrice();
      price.code = raw.code;
      price.price = raw.price;
      price.daysDuration = raw.daysDuration;
      return price;
    }
    return null;
  }

  durationValue(): string {
    return durationValue(this.daysDuration);
  }

  durationLabel(): string {
    return durationLabel(this.daysDuration);
  }
}

export default SignPrice;
